import { t } from 'i18next';
import { useCallback } from 'react';
import type { I18nPrefix } from '../../../../i18n/prefix';
import { DOCS_URLS } from '../../constants';
import { useStorefrontOptionsControls } from '../../context/storefront-options-context';
import type { AnalyticsOptions } from '../../types/spark-options';
import { AnalyticsProvidersEditor } from '../analytics-providers-editor';
import { OptionsCard } from '../options-card';

const CARD =
  'features:storefront_options.pages.storefront_options_page.cards.analytics' satisfies I18nPrefix;

export function AnalyticsCard() {
  const { options, set } = useStorefrontOptionsControls();

  const handleChange = useCallback(
    (value: AnalyticsOptions | null) => set('analytics', value),
    [set],
  );

  return (
    <OptionsCard
      title={t(`${CARD}.title`)}
      subtitle={t(`${CARD}.subtitle`)}
      learnMoreUrl={DOCS_URLS.analytics}
    >
      <AnalyticsProvidersEditor value={options.analytics} onChange={handleChange} />
    </OptionsCard>
  );
}
